<ui-headline-wrapper>
    @if (readonlyMode$ | async) {
        <ui-headline [title]="'modules.partners.head' | translate" />
    } @else {
        <ui-headline [title]="'modules.partners.head' | translate" [headlineButtonContext]="headlineButtonContext" [content]="content" />
    }
</ui-headline-wrapper>

<ui-content-wrapper [colAdditionalClass]="'px-0'" [classPx]="'px-3'">
    <users-partners-grid
        [readonly]="readonlyMode$ | async"
        [partners]="partners$ | async"
        [pending]="loading$ | async"
        [handlers]="handlersGrid" />
</ui-content-wrapper>
